export class Vorlage {
  id: number = 0;
  name: string = '';
  titel: string = '';
  titelEN: string = '';
  gruppe: string = '';
  type: number = 0;
  docId: string | null = null;
  actionId: string | null = null;

  vorlageTextbausteine: Array<VorlageTextbaustein> = new Array<VorlageTextbaustein>();
  adate: Date = new Date();
  mdate: Date = new Date();
  archivBenutzer: string = '';
}

export class VorlageItem {
  id: number = 0;
  name: string = '';
  titel: string = '';
  gruppe: string = '';
  type: number = 0;
}

export class VorlageTextbaustein {
  id: number;
  vorlageid: number;
  textbausteinid: number;
  textbaustein: Textbaustein;
  position: number;
  optional: boolean;
  abschnittRegeln: Array<VorlageAbschnittRegel>;
  adate: Date;
  mdate: Date;
  archivBenutzer: string;

  constructor(vorlageid: number, textbaustein: Textbaustein, position: number) {
    this.id = 0;
    this.vorlageid = vorlageid;
    this.textbausteinid = textbaustein.id;
    this.textbaustein = textbaustein;
    this.position = position;
    this.optional = false;
    this.abschnittRegeln = new Array<VorlageAbschnittRegel>();
    this.adate = new Date();
    this.mdate = new Date();
    this.archivBenutzer = '';

    this.abschnittRegeln.push(new VorlageAbschnittRegel(this.id, this.textbausteinid, false));

    for (let abschnitt of textbaustein.abschnitte) {
      this.abschnittRegeln.push(new VorlageAbschnittRegel(this.id, abschnitt.id, true));
    }
  }
}

export class VorlageAbschnittRegel {
  id: number = 0;
  vorlageTextbausteinId: number = 0;
  textbausteinId: number = 0;
  optional: boolean = true;
  aktiv: boolean = true;
  regeln: Array<AbschnittRegel> = new Array<AbschnittRegel>();

  constructor(vorlageId: number, textbausteinId: number, optional: boolean) {
    this.vorlageTextbausteinId = vorlageId;
    this.textbausteinId = textbausteinId;
    this.optional = optional;
  }
}

export class AbschnittRegel {
  id: number = 0;
  vorlageAbschnittRegelId: number = 0;
  textbausteinId: number = 0;
  effekt: number = 0; // 0=Optional, 1=required, 2=forbidden

  constructor(vorlageAbschnittRegelId: number, textbausteinId: number, effekt: number) {
    this.vorlageAbschnittRegelId = vorlageAbschnittRegelId;
    this.textbausteinId = textbausteinId;
    this.effekt = effekt;
  }
}

export class Textbaustein {
  id: number = 0;
  name: string = '';
  gruppe: string = '';
  titel: string = '';
  text: string = '';

  titelEN: string = '';
  textEN: string = '';

  infotext: string = '';
  isSignaturBaustein: boolean = false;
  position: number = 1;
  ownerid: number | null = null;
  abschnitte: Array<Textbaustein> = new Array<Textbaustein>();
  // abschnitteRegeln: Array<TextbausteinAbschnittRegel> = new Array<TextbausteinAbschnittRegel>();
  adate: Date = new Date();
  mdate: Date = new Date();
  archivBenutzer: string = '';
}

export class DeleteTextbausteinData {
  id: number = 0;
  forceDelete: boolean = false;

  constructor(id: number, forceDelete: boolean = false) {
    this.id = id;
    this.forceDelete = forceDelete;
  }
}

export class TextbausteinAbschnittRegel {
  id: number;
  textbausteinId: number;
  name: string;
  value: string;

  constructor(textbausteinid: number, name: string) {
    this.id = 0;
    this.textbausteinId = textbausteinid;
    this.name = name;
    this.value = '';
  }
}

export class Variable {
  id: number = 0;
  titel: string = '';
  gruppe: string = '';
  platzhalter: string = '';
  herkunft: string = '';
  feld: string = '';
  type: string = 'text';
  values: Array<VariableValue> = new Array<VariableValue>();
  minLength: number = 0;
  maxLength: number = 80;
  validationType: string | null = 'text'; // "text", "int", "float", "currency
  adate: Date = new Date();
  mdate: Date = new Date();
  archivBenutzer: string = '';
}

export class VariableValue {
  id: number = 0;
  variableid: number = 0;
  type: string;
  value: string = '';
  valueEN: string = '';

  constructor(type: string) {
    this.type = type;
  }
}

export class GroupedVorlagen {
  [key: string]: Vorlage[];
}

export class GroupedVorlagenItems {
  [key: string]: VorlageItem[];
}

export class GroupedTextbausteine {
  [key: string]: Textbaustein[];
}

export class GroupedVariablen {
  [key: string]: Variable[];
}
